import RouterParametersController from './RouterParametersController'

function install(Vue) {
  Vue.component(RouterParametersController.name, RouterParametersController)
}

export default {
  install,
}
